import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_terminal_types',
};

export const getTerminalTypesRequest = () =>
  createRequest({
    url: config.url,
    method: config.method,
  });
